import React from 'react'
import { Input, Card, Button } from 'antd'
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons'
import { useFormikContext, FieldArray } from 'formik'
import { FormField, ArrayItemCard, RemoveButton } from './shared'
import { useFieldPath } from './TabContext'
import { get } from 'lodash'

const { TextArea } = Input

export const RequirementsSection: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>()

  const subtitlePath = useFieldPath('sections.requirements.subtitle')
  const htmlPath = useFieldPath('sections.requirements.html')
  const notePath = useFieldPath('sections.requirements.note')
  const modulesPath = useFieldPath('sections.requirements.modules')

  const modules = get(values, modulesPath, [])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFieldValue(e.target.name, e.target.value)
  }

  return (
    <Card>
      <FormField>
        <label>Subtítulo</label>
        <TextArea
          name={subtitlePath}
          value={get(values, subtitlePath, '')}
          onChange={handleChange}
          rows={2}
          placeholder="Subtítulo da seção"
        />
      </FormField>

      <FormField>
        <label>Subtítulo (HTML opcional)</label>
        <TextArea
          name={htmlPath}
          value={get(values, htmlPath, '')}
          onChange={handleChange}
          rows={4}
          placeholder="Cole o HTML formatado do subtítulo (opcional)"
        />
      </FormField>

      <FormField>
        <label>Nota</label>
        <Input
          name={notePath}
          value={get(values, notePath, '')}
          onChange={handleChange}
          placeholder="Nota adicional sobre requisitos"
        />
      </FormField>

      <h4>Módulos do Curso</h4>
      <FieldArray name={modulesPath}>
        {(arrayHelpers) => (
          <>
            {modules.map((module, index) => (
              <ArrayItemCard key={index}>
                <RemoveButton>
                  <Button
                    type="text"
                    danger
                    size="small"
                    icon={<DeleteOutlined />}
                    onClick={() => arrayHelpers.remove(index)}
                  />
                </RemoveButton>
                <FormField>
                  <label>ID do Módulo</label>
                  <Input
                    name={`${modulesPath}.${index}.id`}
                    value={module.id}
                    onChange={handleChange}
                    placeholder="1"
                  />
                </FormField>
                <FormField>
                  <label>Título do Módulo</label>
                  <Input
                    name={`${modulesPath}.${index}.title`}
                    value={module.title}
                    onChange={handleChange}
                    placeholder="Ex: Legislação de Trânsito"
                  />
                </FormField>
                <FormField>
                  <label>Horas</label>
                  <Input
                    name={`${modulesPath}.${index}.hours`}
                    value={module.hours}
                    onChange={handleChange}
                    placeholder="Ex: 10 h"
                  />
                </FormField>
                <FormField>
                  <label>Conteúdo</label>
                  <TextArea
                    name={`${modulesPath}.${index}.content`}
                    value={module.content}
                    onChange={handleChange}
                    rows={4}
                    placeholder="Descrição detalhada do conteúdo do módulo"
                  />
                </FormField>
              </ArrayItemCard>
            ))}
            <Button
              type="dashed"
              onClick={() => arrayHelpers.push({ id: '', title: '', hours: '', content: '' })}
              block
              icon={<PlusOutlined />}
            >
              Adicionar Módulo
            </Button>
          </>
        )}
      </FieldArray>
    </Card>
  )
}
